export const PERMISSION_DENIED_MESSAGE =
  'Você não tem permissão para acessar este serviço, verifique com o administrador';
export const NOT_FOUND_MESSAGE = 'Endereço não encontrado';
export const DEFAULT_MESSAGE = 'Falha no servidor, tente novamente mais tarde';

export const RESPONSE_MESSAGES_BY_CODE = {
  401: PERMISSION_DENIED_MESSAGE,
  403: PERMISSION_DENIED_MESSAGE,
  404: NOT_FOUND_MESSAGE,
  500: DEFAULT_MESSAGE,
  502: DEFAULT_MESSAGE,
  503: DEFAULT_MESSAGE,
  504: DEFAULT_MESSAGE
};

/**
 * This helper intends to translate generic
 * HTTP error codes to user friendly messages.
 *
 * @param {int} statusCode HTTP status code
 * @param {object} customMessages Custom message mapping
 */
export const translateStatusCode = (statusCode, customMessages = {}) => {
  // Merges messages objects into default one, avoiding manipulating original objects
  const responseMessage = {
    ...RESPONSE_MESSAGES_BY_CODE,
    ...customMessages
  };
  return responseMessage[statusCode] || DEFAULT_MESSAGE;
};
